module.exports = __webpack_public_path__ + "img/model-3.0a39fe7c.svg";